/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Carousel_ItemInputs */

const da_forside_carousel_item = /** @type {(inputs: Forside_Carousel_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`citat`)
};

/** @type {(inputs: Forside_Carousel_ItemInputs) => LocalizedString} */
const en_forside_carousel_item = da_forside_carousel_item;

/**

* @param {Forside_Carousel_ItemInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_carousel_item = /** @type {((inputs?: Forside_Carousel_ItemInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Carousel_ItemInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_carousel_item(inputs)
	return /** @type {LocalizedString} */ ("citat")
});